import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

export function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    // main.tsx already called handleRedirectPromise() before the React app rendered,
    // consuming the MSAL auth state and storing any returnUrl from MSAL's state parameter
    // into localStorage. Calling handleRedirectPromise() again here would return null
    // (state already consumed), causing us to miss the MSAL state value.
    //
    // All we need to do is read the returnUrl and redirect.

    const redirect = () => {
      try {
        let returnUrl = localStorage.getItem('returnUrl')
        if (import.meta.env.DEV) console.log('AuthCallback: returnUrl from localStorage:', returnUrl)

        // Guard against poisoned returnUrl pointing back to /auth/callback
        // (can happen if the URL was saved before MSAL events updated isAuthenticated)
        if (returnUrl && returnUrl.startsWith('/auth/callback')) {
          if (import.meta.env.DEV) console.log('AuthCallback: Discarding self-referencing returnUrl:', returnUrl)
          localStorage.removeItem('returnUrl')
          returnUrl = null
        }

        if (returnUrl) {
          if (import.meta.env.DEV) console.log('AuthCallback: Navigating to saved URL:', returnUrl)
          navigate(returnUrl, { replace: true })
        } else {
          if (import.meta.env.DEV) console.log('AuthCallback: No saved URL, redirecting to employee-journey')
          navigate('/employee-journey', { replace: true })
        }
      } catch (error) {
        console.error('AuthCallback error:', error)
        navigate('/employee-journey', { replace: true })
      }
    }

    // Small delay to ensure MSAL state and React Router are settled
    const timer = setTimeout(redirect, 150)
    return () => clearTimeout(timer)
  }, [navigate])

  // Always render the loader — never return null.
  // The component unmounts naturally when navigate() completes the route change.
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20 flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-heritage-blue mx-auto" />
        <p className="text-sm text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  )
}
